import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Select } from '@ipc/ipc-components';
import { getLeftCheckedMailProcessingCenters } from '../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import ImpcStockLevelsAllTableContainer from './ImpcStockLevelsAllTableContainer';
import ImpcStockLevelsAlertsTableContainer from './ImpcStockLevelsAlertsTableContainer';
import ImpcStockLevelsCentralEntryPointTableContainer from './ImpcStockLevelsCentralEntryPointTableContainer';
import { tableClickedRowSetSuccess, tableLoadData } from '../../../common/tables/actions/ListTableActions';
import TransactionsTabsPanel from '../transactions/component/TransactionsTabsPanel';
import ImpcCharacteristicsTabsPanel from '../transactions/component/ImpcCharacteristicsTabsPanel';
import OperatorImpcSelectionCriteriaContainer
  from '../../../common/selection-criteria/operator-impc/container/OperatorImpcSelectionCriteriaContainer';
import TableDefinitions from '../../../common/TableDefinitions';
import { getClickedRowOnTable } from '../../../common/tables/reducers/selectors/ListTableSelectors';

const options = [
  { label: 'View All IMPCs', value: 'ALL', state: { tableId: 'IMPC_STOCK_LEVELS_ALL_LIST' } },
  { label: 'View IMPCs with Alerts', value: 'ALERTS', state: { tableId: 'IMPC_STOCK_LEVELS_WITH_ALERTS_LIST' } },
  {
    label: 'View only Central Entry points',
    value: 'CEP',
    state: { tableId: 'IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT' },
  },
];

class ImpcStockLevelsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTable: 'ALL',
      showResult: false,
    };
    this.selectedRow = this.selectedRow.bind(this);
  }

  componentDidMount() {
    if (this.props.clickedRow !== undefined) {
      this.props.tableLoadData({ tableId: 'IMPC_STOCK_LEVELS_ALL_LIST' }, this.props.appContext.appContext, { impcCodes: this.props.checkedMailProcessingCenters });
      this.setState({
        showResult: true,
      });
    }
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });
    this.handleChangeTable({ label: 'View All IMPCs', value: 'ALL', state: { tableId: 'IMPC_STOCK_LEVELS_ALL_LIST' } });
  };

  handleChangeTable = (option) => {
    if (option.value === 'ALERTS') {
      this.props.tableLoadData(option.state, this.props.appContext.appContext, { impcCodes: this.props.checkedMailProcessingCenters });
    } else if (option.value === 'CEP') {
      this.props.tableLoadData(option.state, this.props.appContext.appContext, { impcCodes: this.props.checkedMailProcessingCenters });
    } else {
      this.props.tableLoadData(option.state, this.props.appContext.appContext, { impcCodes: this.props.checkedMailProcessingCenters });
    }

    this.setState({
      selectedTable: option.value,
    });

    // Reset selected row so that index will be -1.
    this.props.tableClickedRowSetSuccess({}, TableDefinitions.IMPC_STOCK_LEVELS_ALL_LIST);
  };

  refreshTableForBoh = () => {
    if (this.state.selectedTable === 'ALL') {
      this.props.tableLoadData({ tableId: 'IMPC_STOCK_LEVELS_ALL_LIST' }, this.props.appContext.appContext, { impcCodes: this.props.checkedMailProcessingCenters });
    } else if (this.state.selectedTable === 'CEP') {
      this.props.tableLoadData({ tableId: 'IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT' }, this.props.appContext.appContext, { impcCodes: this.props.checkedMailProcessingCenters });
    } else {
      this.props.tableLoadData({ tableId: 'IMPC_STOCK_LEVELS_WITH_ALERTS_LIST' }, this.props.appContext.appContext, { impcCodes: this.props.checkedMailProcessingCenters });
    }
  }

  selectedRow = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      if (rowInfo.index === 0) {
        this.props.tableClickedRowSetSuccess(rowInfo.row);
      }
      return {
        onClick: (e) => {
          this.props.tableClickedRowSetSuccess(rowInfo.row, TableDefinitions.IMPC_STOCK_LEVELS_ALL_LIST);
        },
        style: {
          cursor: 'pointer',
        },
      };
    }
    return {};
  };

  render() {
    const { _index: index } = this.props.clickedRow || { _index: -1 };

    return (
      <div>
        <OperatorImpcSelectionCriteriaContainer
          open={this.props.clickedRow === undefined}
          title="IMPC STOCK LEVELS"
          onApply={this.onCriteriaApply}
        />
        <div className="general-content-container">
          {(this.state.showResult) && (
            <div className="general-half-left-container">
              <div className="select-div">
                <Button
                  style={{ float: 'right', margin: '12px' }}
                  onClick={this.refreshTableForBoh}
                  className="action-buttons primary-button-false"
                >
                  Refresh
                </Button>
                <div className="selected-impc">
                  <Select
                    value={options.value}
                    placeholder="View All IMPCs"
                    options={options}
                    onChange={this.handleChangeTable}
                  />
                </div>
              </div>
              <div className="list-table-container">
                {this.state.selectedTable === 'ALL' && (
                  <ImpcStockLevelsAllTableContainer
                    selectedRow={this.selectedRow}
                    selectedRowIndex={index}
                  />
                )}
                {this.state.selectedTable === 'ALERTS' && (
                  <ImpcStockLevelsAlertsTableContainer
                    selectedRow={this.selectedRow}
                    selectedRowIndex={index}
                  />
                )}
                {this.state.selectedTable === 'CEP' && (
                  <ImpcStockLevelsCentralEntryPointTableContainer
                    selectedRow={this.selectedRow}
                    selectedRowIndex={index}
                  />
                )}
              </div>
            </div>
          )}
          {index > -1 && (
            <div className="general-half-right-container">
              <ImpcCharacteristicsTabsPanel />
            </div>
          )}
        </div>
        {index > -1 && (
          <div className="general-transactions-content-container">
            <TransactionsTabsPanel />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
  };
}

ImpcStockLevelsContainer.propTypes = {
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.any),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableClickedRowSetSuccess: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  tableClickedRowSetSuccess,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImpcStockLevelsContainer);
